<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data(){
      return{
      }
    },
    methods:{
      setTimer () {
        if (this.timer) clearTimeout(this.timer);
        // 先判断有没有用户信息，用户为登录状态再添加提示
        var namesty = localStorage.getItem("name")
        if (namesty) {
          this.timer = setTimeout(() => {
            localStorage.setItem("name", "");
            this.$message.error('您已经超过30分钟未进行任何操作，请重新登录');
            setTimeout(() => {
              location.reload();
            },1000);
          },30*60* 1000)
        }
      },

    },
    created(){
      // 添加30min不操作就会清除用户信息事件
      window.addEventListener('mousedown', (e) => {
        this.setTimer();
      }, true);
      window.addEventListener('keyup', (e) => {
        this.setTimer();
      }, true);
      window.addEventListener('scroll', (e) => {
        this.setTimer();
      }, true)

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// App.vue?88416e3e